import { useEffect, useRef } from 'react';
import { subscribeTVActions } from '../tvNavigation/actions';

type PlayerTVRemoteControlsOptions = {
  enabled: boolean;
  controlsVisible: boolean;
  menuOpen: boolean;
  onRevealControls: () => void;
  onTogglePlayerControls: () => void;
  onTogglePlayback: () => void;
  onSeek: (direction: -1 | 1) => void;
  onAdjustVolume: (direction: -1 | 1) => void;
  onToggleMute: () => void;
  onPreviousEpisode: () => void;
  onNextEpisode: () => void;
};

/** Consumes the same normalized actions as native TV builds. */
export function usePlayerTVRemoteControls(options: PlayerTVRemoteControlsOptions) {
  const optionsRef = useRef(options);
  optionsRef.current = options;

  useEffect(() => subscribeTVActions(({ action }) => {
    const current = optionsRef.current;
    if (!current.enabled) return;
    if (action === 'togglePlayerControls') {
      current.onTogglePlayerControls();
    } else if (action === 'up' || action === 'down' || action === 'left' || action === 'right') {
      if (!current.controlsVisible && !current.menuOpen) current.onRevealControls();
    } else if (action === 'playPause') {
      current.onRevealControls();
      current.onTogglePlayback();
    } else if (action === 'seekBackward' || action === 'seekForward') {
      current.onRevealControls();
      current.onSeek(action === 'seekForward' ? 1 : -1);
    } else if (action === 'volumeUp' || action === 'volumeDown') {
      current.onAdjustVolume(action === 'volumeUp' ? 1 : -1);
    } else if (action === 'mute') {
      current.onToggleMute();
    } else if (action === 'previousEpisode') {
      current.onPreviousEpisode();
    } else if (action === 'nextEpisode') {
      current.onNextEpisode();
    }
  }), []);
}
